import { combineReducers } from 'redux';

import shipsReducer from './ships';
import languageReducer from './language-reducer';
import networkErrorReducer from './network-errors-reducer';
import { LogbookSelectorReducer } from './logbookSelector-reducer';
import { desktopTableReducer } from './desktopTable-reducer';
import { desktopMapReducer } from './desktopMap-reducer';
import { mapAndTableModalsReducer } from './mapAndTableModals-reducer';
import { routeSelectorReducer } from './routeSelector-reducer';
import { LogbookHighlighterReducer } from './logbookHighlighter-reducer';

const appReducer = combineReducers({
  language: languageReducer,
  errors: networkErrorReducer,
  logbooks: LogbookSelectorReducer,
  logbookHighlighter: LogbookHighlighterReducer,
  routingTable: desktopTableReducer,
  maps: desktopMapReducer,
  modals: mapAndTableModalsReducer,
  routes: routeSelectorReducer,
  ships: shipsReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
